// extracted by mini-css-extract-plugin
export default {"reviewsWrapper":"reviewsWrapper--mp-NjA94","headerWrapper":"headerWrapper--mp-vjEh9","spinnerContainer":"spinnerContainer--mp-TuTon"};